/**
 * Wordmark APOLLO Break News.
 * Une seule image unifiée "Break apollo" (logo + nom) sur fond noir.
 * Ratio : 1044/331 ≈ 3.154 — strictement préservé via height + width auto.
 */

const RATIO = 3.154;

function Mark({ height, className = "", testid }) {
  return (
    <img
      src="/break-apollo-logo.png"
      alt="APOLLO Break News"
      className={className}
      data-testid={testid}
      style={{
        height,
        width: height * RATIO,
        objectFit: "contain",
        display: "block",
        borderRadius: 8,
      }}
    />
  );
}

/** Login — grand format. */
export function WordmarkStacked({ className = "" }) {
  return (
    <div className={className}>
      <Mark height={120} testid="wordmark-stacked" />
    </div>
  );
}

/** Header — petit format. */
export function WordmarkShort({ className = "" }) {
  return (
    <div className={className}>
      <Mark height={38} testid="wordmark-short" />
    </div>
  );
}

/** Inline (DevSwitchUser) — taille intermédiaire. */
export function WordmarkInline({ className = "" }) {
  return (
    <div className={className}>
      <Mark height={44} testid="wordmark-inline" />
    </div>
  );
}
